export function copyToClipboard(text: string) {
  // 创建一个隐藏的输入元素
  const input = document.createElement('input');
  // 设置输入元素的值为要复制的文本
  input.value = text;
  // 将输入元素添加到文档中
  document.body.appendChild(input);
  // 选择输入元素的内容
  input.select();
  // 执行复制命令
  document.execCommand('copy');
  // 移除输入元素
  document.body.removeChild(input);
}

export function sprintf(txt: string, obj: any) {
  let result = txt;
  Object.keys(obj).forEach((key: string) => {
    result = result.replace(`{${key}}`, obj[key]);
  });
  return result;
}

export function getArgFromUrl(name: string) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const paramsBackup = new URLSearchParams(url.hash.split('?')[1]);
  return params.get(name) || paramsBackup.get(name);
}

export function formaTimeForTsToH(time: number) {
  const hours = time / 1000 / 60 / 60;
  const truncated = Math.floor(hours * 100) / 100; // 保留两位小数但不四舍五入
  return truncated;
}

export function formatScore(num: number) {
  if (num >= 1000) {
    // 将数字除以1000并保留一位小数
    return Math.floor(num / 100) / 10 + 'k';
  }
  return String(num);
}
